export const MENTORING = {
  client_name: "fhmentoring",
  client_id: "26",
};
